import * as React from 'react'
import Svg, { Circle, Defs, LinearGradient, Stop, SvgProps } from 'react-native-svg'

export const UpspaceGradientLogoMark = (props: SvgProps) => (
  <Svg width={36} height={36} fill='none' {...props}>
    <Circle cx={24.998} cy={25.002} r={21.154} fill='url(#a)' />
    <Circle cx={25} cy={25} r={24} stroke='#D1D3D4' strokeWidth={2} />
    <Defs>
      <LinearGradient
        id='a'
        x1={3.844}
        y1={6.252}
        x2={48.414}
        y2={37.913}
        gradientUnits='userSpaceOnUse'
      >
        <Stop stopColor='#FF3E6C' />
        <Stop offset={1} stopColor='#4071EB' />
      </LinearGradient>
    </Defs>
  </Svg>
)
